import { cataloguesApi } from "@/services/dashboard-api.client";
import type { IngestTriggerResult } from "@sakura-tech-lab/dashboard-api";

// Generated response type: only jobId is guaranteed by the dashboard API.
export type IngestResponse = IngestTriggerResult;

export const ProductIngestService = {
  async importProducts(catalogueId: string, fileUrl: string, format: string = 'csv'): Promise<IngestResponse> {
    const response = await cataloguesApi.ingestCatalogueProducts({
      ingestCatalogueProductsRequest: {
        catalogueId,
        fileUrl,
        format,
      },
    });
    if (!response.data) throw new Error("Failed to start ingestion");
    return response.data;
  }
};
